/* ═══ AgIconButton — Anagogia Design System ═══ */

import { forwardRef } from 'react';
import styles from './AgIconButton.module.css';

interface AgIconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Button size: sm=28px, md=36px, lg=44px */
  size?: 'sm' | 'md' | 'lg';
  /** Visual style */
  variant?: 'default' | 'primary' | 'ghost';
  /** Icon element (typically a MUI icon) */
  children: React.ReactNode;
}

/**
 * Bouton icône compact pour actions secondaires (barres d'outils, cartes).
 * @category Boutons
 */
const AgIconButton = forwardRef<HTMLButtonElement, AgIconButtonProps>(
  function AgIconButton(
    { size = 'md', variant = 'default', type = 'button', children, className, ...rest },
    ref,
  ) {
    const cls = [
      styles.iconButton,
      styles[variant],
      styles[size],
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button ref={ref} type={type} className={cls} {...rest}>
        {children}
      </button>
    );
  },
);

export { AgIconButton };
export type { AgIconButtonProps };
export default AgIconButton;
